import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import WrittenPaperPage from '../../features/interview/components/WrittenPaperPage';

const WrittenPaperPageRoute = () => (
  <ProtectedRoute requiresAuth={true}>
    <WrittenPaperPage />
  </ProtectedRoute>
);

export default WrittenPaperPageRoute;
